import { alpha } from '@mui/material';

export default theme => ({
  mainContainer: {
    padding: theme.spacing(3, 0, 1.5)
  },
  content: {
    display: 'flex',
    flexDirection: 'column'
  },
  icon: {
    color: alpha(theme.palette.secondary.main, 0.54),
    fontSize: theme.spacing(2),
    margin: theme.spacing(0.5, 0, 0, 0.5)
  },
  divider: {
    marginTop: theme.spacing(3)
  }
});
